<template>
    <LoaderImg v-if="loading && showLoader"></LoaderImg>
    <img :src="image" :alt="name" v-else-if="!loading">
</template>

<script>
    import LoaderImg from "./LoaderImg";

    export default {
        name: 'ImageLoader',
        components: {LoaderImg},
        props: {
            'name': {
                type: String
            },
            'src': {
                type: String
            },
            'errorimage': {
                type: String,
                default: '/src/img/error.png'
            },
            'showLoader': {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                loading: false,
                image: '',
                loader: '/src/img/loader.gif'
            }
        },
        computed: {
            host: function () {
                return this.$store.getters.host();
            },
        },
        created() {
            // loading image
            this.load();
        },
        methods: {
            load: function () {
                // show loader image
                this.loading = true;
                this.image = this.loader;

                // prepare image source
                let image = new Image();
                image.src = this.host + this.src;

                // when successfully loaded
                image.onload = function () {
                    this.loading = false;
                    this.image = this.host + this.src;
                    // emit loading event
                    this.$emit('loaded', true);
                }.bind(this);

                // when loading failed
                image.onerror = function () {
                    this.loading = false;
                    this.image = this.errorimage;
                    // emit loading event
                    this.$emit('loaded', false);
                }.bind(this);
            }
        },
        watch: {
            // trigger image loading when image has changed
            src: function (newVal, oldVal) {
                this.load();
            }
        }
    }
</script>